import { Alert } from "react-bootstrap";

import Loader from "../../../common/components/Loader.tsx";
import { store } from "../../../store/index.ts";
import ProfileComponent from "../components/ProfileComponent.tsx";
import { useGetUserById } from "../hooks/user.hooks.ts";

const ProfileContainer = () => {
  const { authReducer } = store.getState();
  const id = authReducer.user.id;

  const { data, isLoading, error } = useGetUserById(id);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="bg-container">
        <Alert variant="danger">Erreur chargement des données : {error}</Alert>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-container">
        <Alert variant="danger">
          Erreur de récupération des données :<br />
          Veuillez réessayer ultérieurement.
        </Alert>
      </div>
    );
  }

  return <ProfileComponent user={data} id={id} />;
};

export default ProfileContainer;
